var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "left", width: "600", trigger: "hover" } },
    [
      _c("img", {
        attrs: { width: "600", src: _vm.rowData[_vm.fieldData["fieldCode"]] },
      }),
      _vm._v(" "),
      _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
        _c("img", {
          attrs: {
            width: "40",
            height: "40",
            src: _vm.rowData[_vm.fieldData["fieldCode"]],
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }